<div class="d-flex " style="margin-top: 24px;margin-bottom: 24px; margin-left: 44px">
    <div class=" row align-items-center">
        <div class="form-password-toggle d-flex input-group " style="width: 300px; padding-right: 13px">
            <input type="text"
                   class="form-control search-bar"
                   [(ngModel)]="searchTerm"  (ngModelChange)="onSearch()"
                   placeholder="Recherche par mot clé"/>
            <div class="input-group-append" style="margin-right: 10px;">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i
                            data-feather="search" [size]="20"></i></span>
            </div>
        </div>

        <button class="btn btn-outline-primary btn-icon" (click)="toggleFilter()" STYLE="padding: 11px 11px !important;">
            <i data-feather="filter"></i>
        </button>
        <span class="filter-summary" *ngIf="filterSummary" [title]="filterSummary">
            {{ filterSummary }}
            <i
                    class="bi bi-x"
                    style="cursor: pointer;"
                    (click)="clearFilter()">
                    </i>
        </span>

    </div>
    <!-- Filter Panel -->
    <div #filterPanel class="card filter-sidebar length" *ngIf="showFilter" style="width: 320px; max-height: 450px">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                X <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-0"
             style="height: 454px;  box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14);">
            <div class="flex-grow-1 overflow-auto p-1">
                <div class="mb-1">
                    <label class="form-label">Raison sociale</label>
                    <input type="text" class="form-control" [(ngModel)]="filters.raison" />
                </div>
                <div class="mb-1">
                    <label class="form-label">Matricule fiscal</label>
                    <input type="text" class="form-control" [(ngModel)]="filters.matricule" />
                </div>
                <div class="mb-1">
                    <label class="form-label">Chiffre d’affaire</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.chiffre_aff" style="margin-left: 12px;" />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Client endetté</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">Tous</option>
                            <option value=">">Tous</option>
                            <option value="<">Tous</option>
                        </select>
                    </div>
                </div>
                <div class="mb-1">
                    <div class="d-flex w-100" style="gap: 12px;">
                        <div class="flex-grow-1">
                            <label for="dateDu" class="form-label">Date de création</label>
                            <input id="dateDu" type="date" class="form-control m-0" />
                        </div>
                        <div class="flex-grow-1">
                            <label for="dateJusqua" class="form-label">Jusqu’à</label>
                            <input id="dateJusqua" type="date" class="form-control m-0" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="pt-1 border-top d-flex pl-3 " style="gap: 15px; padding-bottom: 19px;">
                <button class="btn btn-outline-secondary" (click)="clearFilter()">Réinitialiser</button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>
    <div class="col-auto ms-auto p-0" style="margin-left: auto; margin-right: 24px;">
        <button type="button" class="btn btn-primary" routerLink="/tiers/fournisseurs/add-fournisseur">+ Ajouter</button>
    </div>
</div>
<!-- Table -->

    <div class="table-responsive">
        <table #table class="table table-hover">
            <thead class="align-middle custom-header"  >
            <tr style="color: rgba(47, 43, 61, 0.9)">
                <th style="font-weight: 500; font-size: 13px; width: 15%">RÉFÉRENCE</th>
                <th class="uppercase" style="font-weight: 500; font-size: 13px; width: 25%">Nom du Responsable</th>
                <th style="font-weight: 500; font-size: 13px; width: 25%">MATRICULE FISCAL</th>
                <th class="uppercase" style="font-weight: 500; font-size: 13px; width: 25%">Chiffre d’affaire</th>
                <th style="font-weight: 500; font-size: 13px; width: 10%">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="isLoading">
                <td colspan="5" style="text-align: center; padding: 2rem;">
                    <div class="spinner-border" role="status" style="color: rgba(19, 74, 211, 1)">
                        <span class="sr-only"></span>
                    </div>
                </td>
            </tr>

            <tr *ngFor="let item of paginatedData; let i = index" class="padd" style="text-align: start;" (click)="viewItem(item)">
                <td class="padd pt-0 pb-0" style="align-items: start;width: 15%"><a href="#" class="ref">#{{  item.id || '-' }}</a></td>
                <td class="padd titre1 pt-0 pb-0" style="width: 25%">{{ item.nom_entreprise || '-' }}<br><p class="titre2 m-0">{{ (item.emails || [])[0]?.email || '-' }}</p> </td>
                <td class="padd titre1 pt-0 pb-0" style="width: 25%">{{ item.numero_identification_fiscale || '-' }}</td>
                <td class="padd pt-0 pb-0" style="width: 25%">{{ item.site_web || 'Non disponible' }}</td>
                <td class="action-icons padd" style="width: 200px">
                    <div class="d-flex" style="gap: 17px">
                        <button class="unstyled-btn" href="#" (click)="openEmailModal(item); $event.preventDefault()" aria-label="Compose Email" title="Envoyer un email" style="color: rgba(0, 186, 209, 1); width: 20px; height: auto;">
                            <span data-feather="mail" [size]="20"></span>
                        </button>
                        <button class="unstyled-btn" href="#" (click)="openPhoneModal(item); $event.preventDefault()" title="Voir numéros de téléphone" style="color: rgba(40, 199, 111, 0.9); width: 20px; height: auto;">
                            <span data-feather="phone" [size]="20"></span>
                        </button>
                        <button class="unstyled-btn" (click)="viewItem(item)" title="Voir les détails" style="color: rgba(47, 43, 61, 0.7); width: 20px; height: auto;">
                            <span data-feather="eye" [size]="20"></span>
                        </button>

                        <div ngbDropdown container="body">
                            <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow" id="dropdownBrowserState{{item.id || i}}" aria-expanded="false"
                               style="color: rgba(47, 43, 61, 0.7); margin-left: 11px; width: 20px; height: auto; display: inline-flex; align-items: center; margin-top: 4px;">
                                <span data-feather="more-vertical" class="cursor-pointer mr-50" [size]="20"></span>
                            </a>
                            <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownBrowserState{{item.id || i}}">
                                <a href="javascript:void(0)" ngbDropdownItem class="d-flex align-items-center" (click)="editItem(item); $event.preventDefault()">
                                    <span data-feather="edit-3" class="mr-50"></span> Modifier
                                </a>
                                <a href="javascript:void(0)" ngbDropdownItem class="d-flex align-items-center" (click)="openModal(item, 'etat'); $event.preventDefault()">
                                    <span data-feather="trash-2" class="mr-50"></span> Archiver
                                </a>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

<div class="pagination-container">
    <div class="row d-flex">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex align-items-center" style="font-size: 15px; margin-left: 24px">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onLimitChange()">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 text-end">
            <div class="d-flex flex-wrap justify-content-end gap-2" style="margin-right: 24px">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«</div>
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(currentPage - 1)">‹</div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage" (click)="changePage(page)">{{ page }}</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(currentPage + 1)">›</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(totalPages)">»</div>
            </div>
        </div>
    </div>
</div>
<div style="height: 116px"></div>


<!-- Archiver Modal -->
<ng-template #bankModal let-modal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card-body d-flex flex-column p-0" style="margin: 30px 64px 64px 64px">
        <div class="overflow-auto " >
            <h2 class="modal-title text-center p-0" style="color: rgba(47, 43, 61, 0.9); font-size: 24px; font-weight: 500;margin-bottom: 24px">
                Voulez-vous désarchiver le fournisseur {{ fournisseurName || '...' }} ?
            </h2>
        </div>
        <div class="p-0 d-flex justify-content-center">
            <button type="button" class="btn btn-primary" (click)="modal.close('Confirm click')" style="margin-right: 15px;">Confirmer</button>
            <button type="button" class="btn" (click)="modal.dismiss('Cancel click')" style="background: rgba(128, 131, 144, 0.16)">Annuler</button>
        </div>
    </div>
</ng-template>

<!-- Phone Numbers Modal -->
<ng-template #phoneModal let-modal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body d-flex flex-column align-items-center">
        <p class="modal-title justify-content-center align-items-center" style="margin-right: 60px; margin-left: 60px; margin-bottom: 24px; font-size: 24px; font-weight: 500; text-align: center;">Numéros de téléphone</p>
        <ul class="phone-list">
            <li *ngFor="let phone of selectedFournisseur?.telephones || []" class="d-flex align-items-center" style="margin-bottom: 24px;">
                <div class="d-flex align-items-center justify-content-center phone-container">
                    <button type="button" class="phone-button">
                        <a [href]="'https://wa.me/' + (phone.code_pays + phone.num_tel)" target="_blank" class="whatsapp-icon" title="Ouvrir WhatsApp" style="color: rgba(0, 162, 14, 0.9);">
                            <span data-feather="phone" class="phone-icon"></span>
                        </a>
                    </button>
                </div>
                <span class="phone-number" style="color: rgba(47, 43, 61, 0.9); font-size: 18px; font-weight: 500; margin-left: 12px;">{{ phone.code_pays }} {{ phone.num_tel }}</span>
            </li>
            <li *ngIf="!(selectedFournisseur?.telephones?.length > 0)" class="text-center">Aucun numéro disponible</li>
        </ul>
    </div>
</ng-template>
<app-email-compose #emailCompose [fournisseurId]="selectedFournisseur?.id || null"></app-email-compose>

<div style="height: 80px"></div>
